/**
 * @typedef {"beat" | "fade" | "beat-fade" | "bounce" | "flip" | "shake" | "spin" | "spin-reverse" | "spin-pulse"} animateType
 */

class AnimateX {

  /**
   * 
   * @param {animateType} type 
   */
  static CSS(type, duration, delay, iterationCount = "infinite"){
    return {
      animation: `fa-${type} ${duration}s`,
      animationDelay: `${delay}s`,
      animationIterationCount: iterationCount
    };
  }
}

export default AnimateX;